// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__rn-vQ","col":"CardReaderDesc_col__12RfF","label":"CardReaderDesc_label__pkcEO"};